var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "primaryGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ff6b35",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ffb347",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#d2691e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#b8621b",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 10,
    fill: "none",
    stroke: "url(#primaryGradient)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    values: "3;4;3",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 6,
    fill: "url(#primaryGradient)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 27,
    x2: 35,
    y2: 35,
    stroke: "url(#primaryGradient)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 20 20;10 20 20;-10 20 20;0 20 20",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8, 45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 12,
    rx: 2,
    fill: "#ffb347",
    stroke: "#d2691e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 12,
    stroke: "#d2691e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 6,
    x2: 16,
    y2: 6,
    stroke: "#d2691e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "4s",
    repeatCount: "indefinite"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 30)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: "bold",
    fill: "url(#textGradient)"
  }, "Khoya"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 60)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: "bold",
    fill: "url(#textGradient)"
  }, "Paya"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 90)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#d2691e"
  }, "Search and find your lost items"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner2);
export default __webpack_public_path__ + "static/media/Partner2.bfb70ea2a45ea401775e9f96cc8d10aa.svg";
export { ForwardRef as ReactComponent };